import dayjs from 'dayjs';
import {
  CLACode,
  ConvertedDutyCalculationValueSleepDuty
} from 'components/admin-portal/Tables/CLA/DutyCalculationValueSleepDuty/types';
import { DutyCalculationValueSleepDutyType } from 'generated/index';

export const convertToInternal = (
  calculationValueSleepDuty?: DutyCalculationValueSleepDutyType
): ConvertedDutyCalculationValueSleepDuty => {
  return calculationValueSleepDuty
    ? {
        ...calculationValueSleepDuty,
        claId: calculationValueSleepDuty.claId,
        valid: {
          from: new Date(calculationValueSleepDuty.validFrom),
          to: new Date(calculationValueSleepDuty.validTo)
        }
      }
    : {
        claId: undefined,
        hourlyWageValue: 0.0,
        hourlyWageValue20: 0.0,
        hourlyWageValue19: 0.0,
        hourlyWageValue18: 0.0,
        hourlyWageValue17: 0.0,
        hourlyWageValue16: 0.0,
        hourlyWageValue15: 0.0,
        valid: {
          from: undefined,
          to: undefined
        }
      };
};

export const convertPayloadForSave = (
  data: ConvertedDutyCalculationValueSleepDuty
): DutyCalculationValueSleepDutyType => {
  return {
    dutyCalculationValueSleepDutyId: data.dutyCalculationValueSleepDutyId,
    claId: data.claId || undefined,
    validFrom: dayjs(data.valid.from).startOf('day').toISOString(),
    validTo: dayjs(data.valid.to).startOf('day').toISOString(),
    hourlyWageValue: data.hourlyWageValue,
    hourlyWageValue15: data.hourlyWageValue15,
    hourlyWageValue16: data.hourlyWageValue16,
    hourlyWageValue17: data.hourlyWageValue17,
    hourlyWageValue18: data.hourlyWageValue18,
    hourlyWageValue19: data.hourlyWageValue19,
    hourlyWageValue20: data.hourlyWageValue20
  };
};

export const convertResponseToOptions = (response: CLACode[] | undefined) => {
  return response
    ? response.map((data) => {
        return {
          value: data.claId,
          label: data.code
        };
      })
    : [];
};
